import { render } from "./BookingFormContact.vue?vue&type=template&id=5db913c4&scoped=true"
import script from "./BookingFormContact.vue?vue&type=script&lang=js"
export * from "./BookingFormContact.vue?vue&type=script&lang=js"

import "./BookingFormContact.vue?vue&type=style&index=0&id=5db913c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db913c4"]])

export default __exports__